var AlligatorView, Backbone, SupportHelpWizardController, SupportLegacyOrderBanner, SupportMainContentWrapperView, SupportProgressBarView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportUtilsHelper, SupportV2CurrentOrderView, SupportV2SelectDifferentOrderMenuView, SupportV2StepOneView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMainContentWrapperView = require('../main_content_view');

SupportV2CurrentOrderView = require('../order_related/v2_current_order_view');

SupportStepActionsView = require('../step_actions_view');

SupportV2SelectDifferentOrderMenuView = require('../order_related/v2_select_different_order_menu_view');

SupportProgressBarView = require('../progress_bar_view');

SupportUtilsHelper = require('../../helpers/utils');

AlligatorView = require('../../../../shared/frontend/views/alligator_view');

SupportHelpWizardController = require('../../helpWizardController');

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

SupportLegacyOrderBanner = require('../legacy_order_banner_view');

Backbone = require('backbone');

Backbone.$ = $;

SupportV2StepOneView = (function(superClass) {
  extend(SupportV2StepOneView, superClass);

  function SupportV2StepOneView() {
    return SupportV2StepOneView.__super__.constructor.apply(this, arguments);
  }

  SupportV2StepOneView.prototype.className = 'v2 step-one horizontal';

  SupportV2StepOneView.prototype.initialize = function() {
    this.id = 1;
    this.I18nScope = 'modules.support';
    Groupon.Support.Email = {};
    this.stepActions = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    this.mainContentWrappper = new SupportMainContentWrapperView;
    return this.createSubViews();
  };

  SupportV2StepOneView.prototype.resetContentModelParams = function() {
    if (Groupon.Support.ContentModel != null) {
      Groupon.Support.ContentModel.escalateToMerchant = false;
      return Groupon.Support.ContentModel.isRefundEligible = false;
    }
  };

  SupportV2StepOneView.prototype.renderOrderDetails = function() {
    window.hideFooterLinks();
    this.resetContentModelParams();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderLegacyOrderBanner(contentWrapper);
        _this.renderSelectDifferentOrderDetailMenu(contentWrapper);
        return _this.renderCurrentOrder(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    this.renderOrderDetailsStepActions();
    return this.hideComponents();
  };

  SupportV2StepOneView.prototype.renderSelectDifferentOrderListingMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.renderOrderListing();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV2StepOneView.prototype.renderSelectDifferentOrderDetailMenu = function(contentWrapper) {
    this.selectDifferentOrderMenu.renderDetails();
    return contentWrapper.append(this.selectDifferentOrderMenu.el);
  };

  SupportV2StepOneView.prototype.renderCurrentOrder = function(contentWrapper) {
    this.currentOrderView.render();
    return contentWrapper.append(this.currentOrderView.el);
  };

  SupportV2StepOneView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    return AlligatorView.hideWidgets();
  };

  SupportV2StepOneView.prototype.close = function() {
    return this.$el.empty();
  };

  SupportV2StepOneView.prototype.render = function(params) {
    var order;
    if (params == null) {
      params = {};
    }
    order = params.order;
    showLoading(this.$el);
    if (!Groupon.Support.OrdersCollection.hasOrders()) {
      return this.initOrdersFetch();
    } else if (order) {
      return this.getOrderDetails(order);
    } else {
      return this.renderOrderListing();
    }
  };

  SupportV2StepOneView.prototype.initOrdersFetch = function() {
    var _errorCb, _successCb;
    _successCb = (function(_this) {
      return function(orders) {
        return _this.myGrouponSuccessCallback(orders);
      };
    })(this);
    _errorCb = (function(_this) {
      return function() {
        return _this.loadOrderErrorCallback();
      };
    })(this);
    if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return Groupon.Support.currentOrdersFilter.iterator.next(_successCb, _errorCb);
    } else {
      return _errorCb();
    }
  };

  SupportV2StepOneView.prototype.myGrouponSuccessCallback = function(orders) {
    var _errorCb, _successCb;
    if ((orders != null ? orders.length : void 0) > 0) {
      if (window.orderIdFromMyGroupons != null) {
        _successCb = (function(_this) {
          return function(orderDetails) {
            return _this.getOrderMetaData(orderDetails);
          };
        })(this);
        _errorCb = (function(_this) {
          return function() {
            return _this.loadOrderErrorCallback();
          };
        })(this);
        return Groupon.Support.OrderModel.getOrderDetailsForMygrouponsOrderId(_successCb, _errorCb);
      } else {
        return this.renderOrderListing();
      }
    } else if (Groupon.Support.currentOrdersFilter.iterator.hasNext()) {
      return this.initOrdersFetch();
    } else {
      return this.noOrdersView();
    }
  };

  SupportV2StepOneView.prototype.getOrderDetails = function(orderSummary) {
    var _successCb, params;
    _successCb = (function(_this) {
      return function(orderDetails) {
        return _this.getOrderMetaData(orderDetails);
      };
    })(this);
    params = {
      order: orderSummary
    };
    return Groupon.Support.OrderModel.getOrderDetails(params, _successCb, _successCb);
  };

  SupportV2StepOneView.prototype.getOrderMetaData = function(orderDetails) {
    var _errorCb, _successCb, params;
    SupportHelpWizardController.changeCurrentOrder(orderDetails);
    if (orderDetails != null) {
      _successCb = (function(_this) {
        return function(order) {
          return _this.handleNormalAndMyGrouponsFlow(order);
        };
      })(this);
      _errorCb = (function(_this) {
        return function() {
          SupportHelpWizardController.changeCurrentOrder(null);
          return _this.loadOrderDetailsErrorCallback();
        };
      })(this);
      Groupon.Support.MAXINDEX = 3;
      Groupon.Support.ORDER_NOT_LISTED = false;
      Groupon.Support.NOT_ORDER_RELATED = false;
      params = {
        order: orderDetails
      };
      return Groupon.Support.OrderModel.getMetadata(params, _successCb, _errorCb);
    }
  };

  SupportV2StepOneView.prototype.handleNormalAndMyGrouponsFlow = function(order) {
    return this.renderOrderDetails();
  };

  SupportV2StepOneView.prototype.loadOrderErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.loadOrderDetailsErrorCallback = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.noOrdersView = function() {
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  SupportV2StepOneView.prototype.renderOrderListing = function() {
    Groupon.Support.MAXINDEX = 3;
    window.hideFooterLinks();
    this.mainContentWrappper.render((function(_this) {
      return function(contentWrapper) {
        _this.renderProgressBar(contentWrapper);
        _this.renderLegacyOrderBanner(contentWrapper);
        return _this.renderSelectDifferentOrderListingMenu(contentWrapper);
      };
    })(this));
    this.$el.html(this.mainContentWrappper.el);
    return this.hideComponents();
  };

  SupportV2StepOneView.prototype.createSubViews = function() {
    this.progressBar = new SupportProgressBarView;
    this.selectDifferentOrderMenu = new SupportV2SelectDifferentOrderMenuView();
    this.currentOrderView = new SupportV2CurrentOrderView();
    return this.legacyOrderBanner = new SupportLegacyOrderBanner;
  };

  SupportV2StepOneView.prototype.renderProgressBar = function(contentWrapper) {
    this.progressBar.render();
    contentWrapper.append(this.progressBar.el);
    return contentWrapper.append("<br>");
  };

  SupportV2StepOneView.prototype.renderLegacyOrderBanner = function(contentWrapper) {
    this.legacyOrderBanner.render();
    return contentWrapper.append(this.legacyOrderBanner.el);
  };

  SupportV2StepOneView.prototype.renderOrderDetailsStepActions = function() {
    this.stepActions.render();
    return this.$el.append(this.stepActions.el);
  };

  return SupportV2StepOneView;

})(Backbone.View);

module.exports = SupportV2StepOneView;

//# sourceMappingURL=data:application/json;base64,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
